<script lang="ts" setup>
defineProps<{
  text: string
}>()
</script>

<template>
  <span class="hidden text-base md:block">
    {{ text }}
  </span>
</template>
